import React, { useEffect, useState } from "react";
import harnessImage from "../assets/images/harness.png";
import { useNavigate } from "react-router-dom";
import { useStripe, useElements } from "@stripe/react-stripe-js";

export default function OrderSummaryCard({ payNowHandler, userCredit = 0, onApplyCredit, appliedCredit = 0, onValidateShipping, clientSecret, checkoutData }) {

const [cartItems, setCartItems] = useState([]);
const [loading, setLoading] = useState(true);
const [processing, setProcessing] = useState(false);
const [qtyError, setQtyError] = useState("");
const stripe = useStripe();
const elements = useElements();
const navigate = useNavigate();

const subtotal = cartItems.reduce(
  (sum, item) => sum + Number(item.price || 0) * Number(item.qty || 0), 0
);
const tax = subtotal * 0.07;
const totalBeforeCredit = subtotal + tax;
const total = Math.max(0, totalBeforeCredit - appliedCredit);

useEffect(() => { fetchCart(); }, []);

const fetchCart = async () => {
  try {
    const response = await fetch("https://eleven11-i6v4.onrender.com/api/cart");
    const data = await response.json();
    setCartItems(Array.isArray(data.items) ? data.items : []);
  } catch (error) {
    console.error("Cart fetch error:", error);
  } finally {
    setLoading(false);
  }
};

const removeItem = async (id) => {
  try {
    await fetch(`https://eleven11-i6v4.onrender.com/api/cart/${id}`, { method: "DELETE" });
    setCartItems((prev) => prev.filter((item) => item._id !== id));
  } catch (error) {
    console.error("Remove item error:", error);
  }
};

const updateQty = async (id, newQty) => {
  if (newQty < 1) return;
  try {
    const res = await fetch(`https://eleven11-i6v4.onrender.com/api/cart/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ qty: newQty })
    });
    const data = await res.json();
    if (!res.ok) {
      setQtyError(data.error || "Could not update quantity");
      setTimeout(() => setQtyError(""), 3000);
      return;
    }
    setCartItems(prev => prev.map(item => item._id === id ? { ...item, qty: newQty } : item));
  } catch (error) {
    console.error("Qty update failed:", error);
  }
};
const handleBNPL = (provider) => {
  if (onValidateShipping && !onValidateShipping()) return;
  navigate("/checkout/bnpl", {
    state: { clientSecret, provider, checkoutData, total }
  });
};

return (
  <div style={styles.card}>
    <h3 style={styles.title}>Order Summary</h3>
    <div style={styles.divider} />

    <div style={styles.items}>
      {cartItems.map((item) => (
        <div style={styles.itemRow} key={item._id}>
          <div style={styles.imageWrapper}>
            <img src={item.image ? `${item.image}` : harnessImage} alt="part" style={styles.image} />
            <button style={styles.removeButton} onClick={() => removeItem(item._id)}>✕</button>
          </div>
          <div style={styles.itemInfo}>
            <div style={styles.itemTitle}>{item.title}</div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 4 }}>
              <div style={styles.qtyStepper}>
                <button style={styles.qtyButton} onClick={() => updateQty(item._id, item.qty - 1)}>−</button>
                <span style={styles.qtyNumber}>{item.qty}</span>
           <button
  style={{ ...styles.qtyButton, opacity: item.qty >= (item.selectedVariant?.stock ?? Infinity) ? 0.4 : 1, cursor: item.qty >= (item.selectedVariant?.stock ?? Infinity) ? "not-allowed" : "pointer" }}
  onClick={() => item.qty < (item.selectedVariant?.stock ?? Infinity) && updateQty(item._id, item.qty + 1)}
>+</button>
              </div>
              {item.selectedCondition && (
                <div style={{ fontSize: 11, fontWeight: 700, padding: "2px 8px", borderRadius: 999, background: item.selectedCondition === "new" ? "#e0f2fe" : "#f3f4f6", color: item.selectedCondition === "new" ? "#0369a1" : "#6b7280", whiteSpace: "nowrap" }}>
                  {item.selectedCondition === "new" ? "Brand New" : "Used"}
                </div>
              )}
            </div>
          </div>
          <div style={styles.price}>
            {(() => {
              const numericPrice = Number(item.price);
              if (!numericPrice || isNaN(numericPrice)) return <span style={{ color: "#ff4d4f", fontSize: 14, fontWeight: 600 }}>Invalid Price</span>;
              return (<><span style={styles.priceMain}>${Math.floor(numericPrice)}</span><span style={styles.priceCents}>{(numericPrice % 1).toFixed(2).substring(2)}</span></>);
            })()}
          </div>
        </div>
      ))}
    </div>

<div style={styles.divider} />

    {qtyError && (
      <div style={{ background: "#FEF2F2", color: "#DC2626", fontSize: 13, fontWeight: 700, padding: "8px 14px", borderRadius: 10, marginBottom: 12, textAlign: "center" }}>
        ⚠ {qtyError}
      </div>
    )}

    <div style={styles.summarySection}>
      <div style={styles.summaryRow}><span>Subtotal:</span><span>${subtotal.toFixed(2)}</span></div>
      <div style={styles.summaryRow}><span>Shipping:</span><span>Free</span></div>
      <div style={styles.summaryRow}><span>Estimated Tax:</span><span>${tax.toFixed(2)}</span></div>

      {userCredit > 0 && (
        <div style={{ marginTop: 12, padding: "12px 14px", borderRadius: 12, background: "#ecfdf5", border: "1px solid #6ee7b7" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: appliedCredit > 0 ? 8 : 0 }}>
            <div>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#065f46" }}>Store Credit</div>
              <div style={{ fontSize: 12, color: "#059669" }}>Available: ${userCredit.toFixed(2)}</div>
            </div>
            {appliedCredit > 0 ? (
              <button onClick={() => onApplyCredit(0)} style={{ fontSize: 12, fontWeight: 700, color: "#dc2626", background: "none", border: "none", cursor: "pointer" }}>Remove</button>
            ) : (
              <button onClick={() => onApplyCredit(Math.min(userCredit, totalBeforeCredit))} style={{ fontSize: 12, fontWeight: 700, color: "#065f46", background: "#d1fae5", border: "none", borderRadius: 8, padding: "6px 12px", cursor: "pointer" }}>Apply</button>
            )}
          </div>
          {appliedCredit > 0 && (
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, color: "#065f46", fontWeight: 600 }}>
              <span>Credit Applied</span><span>−${appliedCredit.toFixed(2)}</span>
            </div>
          )}
        </div>
      )}
    </div>

    <div style={styles.divider} />

    <div style={styles.totalRow}><span>Total</span><span>${total.toFixed(2)}</span></div>

    {/* Pay Now — card */}
    <button
      style={{ ...styles.button, opacity: loading || cartItems.length === 0 ? 0.6 : 1, cursor: loading || cartItems.length === 0 ? "not-allowed" : "pointer" }}
      disabled={loading || cartItems.length === 0}
      onClick={() => {
        if (onValidateShipping && !onValidateShipping()) return;
        if (typeof payNowHandler === "function") payNowHandler();
      }}
      onMouseEnter={(e) => { if (loading || cartItems.length === 0 || !payNowHandler) return; e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.boxShadow = "0 18px 38px rgba(62,111,227,0.45), 0 8px 18px rgba(0,0,0,0.12), inset 0 1px 0 rgba(255,255,255,0.35)"; }}
      onMouseLeave={(e) => { if (loading || cartItems.length === 0 || !payNowHandler) return; e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 10px 20px rgba(62,111,227,0.35), inset 0 1px 0 rgba(255,255,255,0.25)"; }}
    >
      Pay Now (${total.toFixed(2)})
    </button>

{/* BNPL — coming soon */}

    <div style={styles.elevenDivider}>
      <div style={styles.elevenLine} />
      <span style={styles.elevenText}>ELEVEN</span>
      <div style={styles.elevenLine} />
    </div>

    <div style={styles.footer}>
      <span style={styles.footerItem}>⊕ OEM Quality Guaranteed</span>
      <span style={styles.footerDivider}>›</span>
      <span style={styles.footerItem}>Expert Support Included</span>
    </div>
  </div>
);
}

const styles = {
  card: { borderRadius: 22, padding: 22, background: "linear-gradient(180deg,#ffffff 0%,#eef2ff 100%)", border: "2px solid #ffffff", boxShadow: "0 0 30px rgba(120,170,255,0.18), 0 20px 50px rgba(0,0,0,0.10), 0 6px 18px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,1)" },
  elevenDivider: { display: "flex", alignItems: "center", gap: 12, marginTop: 22 },
  qtyStepper: { display: "flex", alignItems: "center", gap: 6, marginTop: 4 },
  qtyButton: { width: 22, height: 22, borderRadius: 6, border: "1px solid #E3E6EE", background: "#f7f8fc", cursor: "pointer", fontSize: 14 },
  qtyNumber: { fontSize: 14, fontWeight: 600, width: 18, textAlign: "center" },
  imageWrapper: { position: "relative" },
  removeButton: { position: "absolute", top: -4, right: -4, width: 18, height: 18, borderRadius: "50%", border: "none", background: "#f5f6fa", color: "#8b93a7", fontSize: 12, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", transition: "all .15s ease" },
  elevenLine: { flex: 1, height: 1, background: "#E6E8EC" },
  elevenText: { fontSize: 14, letterSpacing: 2, color: "#9AA1B2", fontWeight: 500 },
  title: { fontSize: 20, fontWeight: 600, color: "#2F3441", marginBottom: 18 },
  divider: { height: 1, background: "#E6E8EC", margin: "18px 0" },
  items: { display: "flex", flexDirection: "column", gap: 22 },
  itemRow: { display: "grid", gridTemplateColumns: "64px 1fr auto", gap: 14, alignItems: "center" },
  image: { width: 64, height: 64, borderRadius: 12, objectFit: "cover", boxShadow: "0 4px 10px rgba(0,0,0,0.08)" },
  itemInfo: { display: "flex", flexDirection: "column", gap: 4 },
  itemTitle: { fontSize: 15, fontWeight: 600, color: "#2F3441" },
  price: { display: "flex", alignItems: "flex-start", fontWeight: 600 },
  priceMain: { fontSize: 22, color: "#2F3441" },
  priceCents: { fontSize: 14, marginTop: 2, marginLeft: 2 },
  summarySection: { display: "flex", flexDirection: "column", gap: 10, fontSize: 15, color: "#4A4F63" },
  summaryRow: { display: "flex", justifyContent: "space-between" },
  totalRow: { display: "flex", justifyContent: "space-between", fontSize: 24, fontWeight: 600, color: "#2F3441", marginTop: 6 },
  button: { width: "100%", marginTop: 24, padding: "16px 18px", border: "none", borderRadius: 14, background: "linear-gradient(180deg,#5a8efc,#1f57c8)", color: "#FFFFFF", fontSize: 16, fontWeight: 600, letterSpacing: "0.2px", cursor: "pointer", transition: "all .18s ease", boxShadow: "0 10px 20px rgba(62,111,227,0.35), inset 0 1px 0 rgba(255,255,255,0.25)" },
  bnplButton: { width: "100%", padding: "14px 18px", border: "none", borderRadius: 14, fontSize: 14, fontWeight: 600, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 8, transition: "all .18s ease" },
  footer: { marginTop: 18, fontSize: 13, color: "#6F7A8A", display: "flex", alignItems: "center", justifyContent: "center", gap: 10 },
  footerItem: { display: "flex", alignItems: "center", gap: 6 },
  footerDivider: { color: "#9AA1B2" }
};